module.exports = __webpack_public_path__ + "img/foot-emoji.1d763205.svg";